import { render, staticRenderFns } from "./ConfiguratorMobileCategoryHeading.vue?vue&type=template&id=2a7af35a&scoped=true&"
import script from "./ConfiguratorMobileCategoryHeading.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorMobileCategoryHeading.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguratorMobileCategoryHeading.vue?vue&type=style&index=0&id=2a7af35a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7af35a",
  null
  
)

export default component.exports